export default __webpack_public_path__ + "0a557e1d92de29e74a3c86b6211c5ef4.png";